import { PlannedDeliveryWindow } from '@bringg/dashboard-sdk';

export const readMaxTaskCapacity = (pdw: PlannedDeliveryWindow | null | undefined): number | null =>
	pdw?.data?.max_task_capacity ?? null;

export const withMaxTaskCapacityPayload = <T extends object>(pdw: T): T => {
	const { max_task_capacity, ...rest } = pdw as T & { max_task_capacity?: number | null };
	return {
		...rest,
		...(max_task_capacity != null ? { data: { max_task_capacity } } : {})
	} as T;
};
